export default "__VITE_ASSET__DYyW3iaW__"